import React, {Component} from 'react'
import InvoiceItemPage from "./InvoiceItemPage"

class InvoiceItemContainer extends Component {

    render() {
        const historyState = this.props.location.state
        const vHistoryState = Object.assign({}, historyState)
        const {currentPage = 1} = vHistoryState

        return (
            <InvoiceItemPage currentPage={currentPage} idInvoice={this.props.match.params.id}/>
        )
    }

}

export default InvoiceItemContainer